<template>
  <div class="limiter">
    <v-app-bar color="#1565C0" app elevation="0" height="70px" width="100%" flat>
      <v-row align="center" justify="center">
        <v-col cols="12" class="text-center">
          <img src="../assets/logoConsumerBranca.png" alt="Logo do AIConsumer" class="logo-img" width="180">
      </v-col>
      </v-row>
    </v-app-bar>
  <v-container fluid class="px-4 py-3 pb-16">

  <!-- Login & Recovery Section -->
  <v-row v-if="!usuarioLogado" align="center" justify="center" class="mt-4">
    <v-col cols="12" sm="8" md="6" lg="4">
      <!-- Card for Login -->
      <v-card rounded="lg" elevation="3" class="pa-4">
        <v-card-title class="text-h5 text-center" style="color: #1565C0;">
          <v-icon large color="#1565C0" class="mr-2">mdi-account-circle</v-icon>
          Faça seu login
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              label="Matrícula ou CPF"
              prepend-icon="mdi-id-card"
              color="#1565C0"
              v-model="login.matricula"
              :rules="matriculaRules"
              name="matricula"
              type="tel"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-if="!recuperaSenha"
              label="Senha"
              prepend-icon="mdi-lock-outline"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              color="#1565C0"
              v-model="login.senha"
              name="password"
              :rules="passwordRules"
              outlined
              dense
              required                       
              @keydown.enter="acessarConsumidor"
            ></v-text-field>
            <v-btn
              color="#4CAF50"
              class="white--text mt-4"
              block
              rounded
              elevation="2"
              @click="acessarConsumidor"
              v-if="!recuperaSenha"
            >
              <v-icon left>mdi-login</v-icon>
              Continuar
            </v-btn>
            <v-btn
              v-if="!recuperaSenha"
              text
              color="#1565C0"
              class="mt-3"
              block
              @click="recuperaSenha = true"
            >
              Esqueci minha senha
            </v-btn>
            <v-btn
              v-if="recuperaSenha"
              color="#FF9800"
              dark
              class="mt-4"
              block
              rounded
              elevation="2"
              @click="recuperarAcesso"
            >
              <v-icon left>mdi-lock-reset</v-icon>
              Recuperar senha
            </v-btn>
            <v-btn
              v-if="recuperaSenha"
              text
              color="#1565C0"
              class="mt-3"
              block
              @click="recuperaSenha = false"
            >
              Voltar para login
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- Main Content -->
  <v-row justify="center" class="my-0" v-else>
    <v-col cols="12" md="10" lg="8">
      
      <!-- Account Balance Card - Versão ultra moderna com gradiente -->
      <v-card class="mb-4 balance-card" style="border-radius: 18px; overflow: hidden;">
        <div class="card-bg-gradient pa-3">
          <!-- Header com nome e ícones -->
          <v-row no-gutters class="mb-1">
            <v-col cols="8">
              <v-card
                flat
                color="transparent"
                class="pa-0 ma-0 avatar-clickable"
                @click="dialogoAlterarDadosCadastrais = true" 
                style="cursor: pointer; position: relative; z-index: 5;"
              >
                <div class="d-flex align-center">
                  <v-avatar color="white" size="36" class="mr-2 elevation-2">
                    <template v-if="consumidor.foto">
                      <v-img :src="consumidor.foto" alt="Foto do aluno"></v-img>
                    </template>
                    <span v-else class="blue--text font-weight-bold">{{ consumidor.nome.split(' ')[0].charAt(0) }}</span>
                  </v-avatar>
                  <div>
                    <span class="white--text text-subtitle-2">Olá,</span>
                    <h3 class="white--text font-weight-bold mt-n1">{{ consumidor.nome.split(' ').slice(0, 2).join(' ') }}</h3>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="4" class="d-flex justify-end align-center">
              <v-btn fab small color="white" elevation="3" class="mr-2 action-btn-highlight" @click="dialogoRodapeConfiguracoes = true">
                <v-icon color="#1565C0">mdi-cog-outline</v-icon>
          </v-btn>
              <v-btn fab small color="white" elevation="3" class="action-btn-highlight" @click="sair">
                <v-icon color="#1565C0">mdi-logout-variant</v-icon>
          </v-btn>
            </v-col>
          </v-row>
          
          <!-- Divider com efeito brilhante -->
          <div class="opacity-divider my-3"></div>

          <!-- Saldo -->
          <div class="mt-2 mb-1">
            <span class="white--text text-subtitle-2 text-uppercase font-weight-medium">Saldo disponível</span>
          </div>
          
          <div class="d-flex justify-space-between align-center mt-1">
            <div>
              <span class="balance-display white--text">
                <span v-if="exibeSaldoCartaoConsumo">R$ {{ valorCartaoConsumo }}</span>
                <span v-else>R$ ••••••</span>
              </span>
            </div>
            <v-btn fab small color="white" elevation="3" class="action-btn-highlight" @click="toggleSaldoVisibility">
              <v-icon color="#1976D2">{{ exibeSaldoCartaoConsumo ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
          </v-btn>
          </div>

          <!-- Card chip decoration -->
          <div class="card-chip"></div>
          <div class="card-circle-1"></div>
          <div class="card-circle-2"></div>
        </div>
      </v-card>

      <!-- Action Buttons - Nova versão com cards modernos -->
      <v-row>
        <v-col cols="12" class="py-0">
          <v-card rounded="lg" elevation="2" class="mb-2" color="white" hover @click="dialogoValorTransacao = true; tipoTransacao = 'PIX'">
            <v-list-item three-line>
              <v-list-item-avatar tile size="56" color="#4CAF50" class="rounded-lg">
                <v-icon large color="white">mdi-cash-plus</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h6">Recarga em Pix</v-list-item-title>
                <v-list-item-subtitle>Adicione créditos ao seu cartão</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-card>
          
          <v-card rounded="lg" elevation="2" class="mb-2" color="white" hover @click="visualizarHistorico">
            <v-list-item three-line>
              <v-list-item-avatar tile size="56" color="#FF9800" class="rounded-lg">
                <v-icon large color="white">mdi-clipboard-text-clock</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h6">Ver histórico</v-list-item-title>
                <v-list-item-subtitle>Consulte suas transações</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-card>
          
          <v-card rounded="lg" elevation="2" class="mb-2" color="white" hover @click="goToCardapio">
            <v-list-item three-line>
              <v-list-item-avatar tile size="56" color="#F44336" class="rounded-lg">
                <v-icon large color="white">mdi-food-fork-drink</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h6">Cardápio</v-list-item-title>
                <v-list-item-subtitle>Veja as opções disponíveis</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-card>

          <v-card rounded="lg" elevation="2" class="mb-2" color="white" hover @click="goToRestricoes">
            <v-list-item three-line>
              <v-list-item-avatar tile size="56" color="#1565C0" class="rounded-lg">
                <v-icon large color="white">mdi-food-off</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h6">Restrição de Itens</v-list-item-title>
                <v-list-item-subtitle>Gerencie os itens bloqueados</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</v-container>
  <v-footer dark fixed padless class="pa-0">     
    <v-card class="flex" flat tile color="#1565C0" width="100%">   
      <v-row justify="center" class="my-2 py-2">      
        <v-col :cols="empresa.logo ? 6 : 12" class="d-flex justify-center align-center">
          <img src="../assets/LogoBrancoHorizontal.png" alt="Logo do AIConsumer" height="32">
        </v-col>
        <v-col cols="6" class="d-flex justify-center align-center" v-if="empresa.logo">
          <img :src="empresa.logo" alt="Logo da Empresa" height="32">
        </v-col>
        </v-row> 
    </v-card>
  </v-footer>

    <v-dialog persistent v-model="dialogoCaptura" max-width="600px">
      <v-card>
        <v-card-title>Leitura do QR Code</v-card-title>
        <v-card-text style="padding: 0px">
          <qrcode-stream @decode="decodificar" v-if="dialogoCaptura"></qrcode-stream>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="fechar">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoConsultaSaldo" max-width="600px">
      <v-card>
        <v-card-title>Leitura do QR Code</v-card-title>
        <v-card-text style="padding: 0px">
          <qrcode-stream @decode="fazerConsultaSaldo" v-if="dialogoConsultaSaldo"></qrcode-stream>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="fechar">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoSolicitaResgate" max-width="600px">
      <v-card>
        <v-card-title>Leitura do QR Code</v-card-title>
        <v-card-text style="padding: 0px">
          <qrcode-stream @decode="fazerSolitacaoResgate" v-if="dialogoSolicitaResgate"></qrcode-stream>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="fechar">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoHistoricoConsumo" max-width="600px">
      <v-card>
        <v-card-title>Leitura do QR Code</v-card-title>
        <v-card-text style="padding: 0px">
          <qrcode-stream @decode="fazerConsultaHistorico" v-if="dialogoHistoricoConsumo"></qrcode-stream>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="fechar">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoSolicitaPin" max-width="400px">
      <v-card>
        <v-card-title>Informe seu PIN</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <p>Informe o código PIN para continuar</p>
          <v-otp-input id="pinTransacao" length="4" color="#474d55" type="number" v-model="pinTransacao"></v-otp-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="fechar">Fechar</v-btn>
          <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="criarTransacao">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoOperacao" max-width="600px">
      <v-card>
        <v-card-text style="padding-bottom: 0px; text-align: center">
          <v-icon size="100" :color="respostaTransacao.resultado == 'SUCESSO' ? 'success' : 'error'">{{ respostaTransacao.resultado == 'SUCESSO' ? 'check_circle' : 'error' }}</v-icon>
          <h1 style="margin: 0px; font-weight: 300">{{ respostaTransacao.consumidor }}</h1>
          <h3 style="margin-bottom: 0px; margin-top: 10px">Saldo</h3>
          <h1 style="margin: 0px; font-weight: 300; margin-top: 10px">R$ {{ respostaTransacao.saldo }}</h1>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="fechar">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoCadastraConsumidor" max-width="400px">
      <v-card>
        <v-card-title v-if="codigoInscricao">Informe seus dados</v-card-title>
        <v-card-title v-else>Cadastrar Consumidor</v-card-title>
        <v-card-subtitle style="color: blue">Preenchimento opcional</v-card-subtitle>
        <v-card-text style="padding-bottom: 0px">
          <v-row dense>
            <v-col cols="12">
              <v-text-field label="CPF" outlined dense hide-details v-model="consumidor.cpf" v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-mask="'###.###.###-##'"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Nome e sobrenome" outlined dense hide-details v-model="consumidor.nome"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="WhatsApp com DDD" outlined dense v-model="consumidor.whatsApp" v-mask="'(##) #####-####'" persistent-hint hint="As notificações serão enviadas para o número informado"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialogoCadastraConsumidor = false">Fechar</v-btn>
          <v-btn text color="primary" @click="criarConsumidor">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoCartao" max-width="800px">
      <v-card>
        <v-card-title>Pagamento no cartão</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-container style="padding: 5px">
            <v-row dense>
              <v-col cols="12" xs="6" sm="12" md="12" lg="6">
                <v-text-field v-model="cobrancaAsaasCartao.creditCard.holderName" outlined dense label="Nome impresso no cartão*" hide-details required color="#474d55"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-text-field v-model="cobrancaAsaasCartao.creditCard.number" outlined dense label="Número do cartão*" v-mask="'#### #### #### ####'" type="tel" hide-details required color="#474d55"></v-text-field>
              </v-col>
              <v-col cols="6" xs="6" sm="12" md="12" lg="3">
                <v-text-field v-model="cobrancaAsaasCartao.creditCard.cpfCnpj" outlined dense label="CPF do titular*" v-mask="'###.###.###-##'" v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular" type="tel" hide-details required color="#474d55"></v-text-field>
              </v-col>
              <v-col cols="6" xs="12" sm="12" md="12" lg="3">
                <v-text-field v-model="cobrancaAsaasCartao.creditCard.ccv" outlined dense label="CVV*" v-mask="'###'" type="password" hide-details required color="#474d55"></v-text-field>
              </v-col>
              <v-col cols="6" xs="6" sm="6" md="12" lg="3">
                <v-select v-model="cobrancaAsaasCartao.creditCard.expiryMonth" outlined dense label="Mês de vencimento*" hide-details :items="mesesVencimento" item-text="titulo" item-value="id" required color="#474d55"></v-select>
              </v-col>
              <v-col cols="6" xs="6" sm="6" md="12" lg="3">
                <v-select v-model="cobrancaAsaasCartao.creditCard.expiryYear" outlined dense label="Ano de vencimento*" hide-details :items="anosVencimento" item-text="titulo" item-value="id" required color="#474d55"></v-select>
              </v-col>
              <v-col cols="6" xs="12" sm="12" md="12" lg="3">
                <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.postalCode" v-mask="'#####-###'" label="CEP*" outlined type="tel" dense hide-details required color="#474d55"></v-text-field>
              </v-col>
              <v-col cols="6" xs="12" sm="12" md="12" lg="3">
                <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.addressNumber" label="Nº do Endereço*" outlined type="tel" dense hide-details required color="#474d55"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.email" label="E-mail*" outlined type="mail" dense hide-details required color="#474d55"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding-top: 0px">
          <v-spacer></v-spacer>
          <v-btn dark @click="dialogoCartao = false" color="error" text>Voltar</v-btn>
          <v-btn dark @click="pagarCartao" color="success" text>Pagar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoPagamentoPix" persistent max-width="500px">
      <v-card rounded="lg">
        <v-toolbar flat color="#4CAF50" dark>
          <v-icon left>mdi-qrcode-scan</v-icon>
          <v-toolbar-title>Pagamento PIX</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" class="text-center pb-0">
              <p class="headline font-weight-bold text-green">R$ {{valorTransacao}}</p>
              </v-col>
            </v-row>
          
          <!-- Instruções de pagamento - mostradas por padrão -->
          <v-card class="mb-4" outlined>
            <v-card-text class="pa-3">
              <p class="subtitle-1 font-weight-medium mb-2">
                <v-icon left color="#4CAF50">mdi-information-outline</v-icon>
                Como pagar com PIX
              </p>
              <ol class="ml-4 body-2">
                <li class="mb-1">Abra o aplicativo do seu banco</li>
                <li class="mb-1">Escolha pagar com PIX Copia e Cola</li>
                <li class="mb-1">Copie o código abaixo e cole no seu aplicativo</li>
                <li>Confirme o pagamento no valor de <b>R$ {{valorTransacao}}</b></li>
              </ol>
            </v-card-text>
                </v-card>
          
          <!-- QR Code - oculto por padrão -->
          <div v-if="exibirQRCode" class="text-center mb-4 mt-2">
            <v-card elevation="0" class="mx-auto qr-card" max-width="220px">
              <div class="qr-container pa-2">
                <qrcode-vue v-if="empresa.gatewayPagamentoPix == 'SICOOB'" 
                  :value="cobrancaPix.qrCode" 
                  :size="200" 
                  level="H" 
                  bg-color="white"
                  class="mx-auto"
                ></qrcode-vue>
                <img v-else 
                  :src="cobrancaPix.qrCode" 
                  width="100%" 
                  style="max-width: 200px"
                  class="mx-auto"
                >
              </div>
            </v-card>
          </div>
          
          <v-row>
            <v-col cols="12">
                  <v-text-field
                    v-model="cobrancaPix.chaveCopiaCola"
                label="Código PIX Copia e Cola"
                    id="chavePix"
                    outlined
                    readonly
                    dense
                hide-details
                append-icon="mdi-content-copy"
                @click:append="doCopy('chavePix')"
                class="pix-code-field"
                  ></v-text-field>
                </v-col>
          </v-row>
          
          <v-row class="mt-3">
            <v-col cols="12" sm="6">
                  <v-btn
                color="#4CAF50"
                    dark
                    depressed
                block
                    @click="doCopy('chavePix')"
                class="px-2"
                  >
                <v-icon left>mdi-content-copy</v-icon>
                    Copiar código
                  </v-btn>
                </v-col>
            <v-col cols="12" sm="6">
                  <v-btn
                :color="exibirQRCode ? 'grey darken-1' : 'primary'"
                :outlined="!exibirQRCode"
                    dark
                    depressed
                block
                    @click="exibirQRCode = !exibirQRCode"
                class="px-2"
                  >
                <v-icon left>{{ exibirQRCode ? 'mdi-eye-off' : 'mdi-qrcode-scan' }}</v-icon>
                    {{ exibirQRCode ? 'Ocultar QR Code' : 'Exibir QR Code' }}
                  </v-btn>
                </v-col>
              </v-row>
          
          <v-row v-if="empresa.gatewayPagamentoPix == 'ASSAS' || empresa.gatewayPagamentoPix == 'TAPAGO'" class="mt-2">
            <v-col cols="12" class="text-center">
              <p class="caption text-grey-darken-1 mb-0">
                <v-icon small color="grey">mdi-store</v-icon>
                {{ empresa.gatewayPagamentoPix == 'ASSAS' ? 'INTELITE TECNOLOGIA' : 'INTELITE TECNOLOGIA FLAGSHIP' }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-divider></v-divider>
        
        <v-card-actions class="pa-4">
          <v-btn
            block
            depressed
            color="primary"
            @click="closeDialog(false)"
            class="px-4"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoConfirmacao" persistent max-width="400px">
      <v-card>
        <v-card-text style="text-align: center; padding-bottom: 0px">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" style="padding-bottom: 0px;">
                <v-icon color="success" size="100">check_circle</v-icon>
              </v-col>
              <v-col cols="12" style="padding: 2px;">
                <p class="texto" style="color: #666; margin: 0px">Recarga realizada com sucesso!</p>
                <p class="texto" style="color: #666; margin: 0px" v-if="saldoCartao">Saldo: R$ {{saldoCartao}}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDialog(true)">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoDadosResgate" max-width="400px">
      <v-card>
        <v-card-title>Informações para resgate</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-row dense>
            <v-col cols="12">
              <v-radio-group v-model="solicitacaoResgate.tipoChavePix">
                <p>Tipo de chave Pix</p>
                <v-radio label="CPF/CNPJ" value="CPF/CNPJ"></v-radio>
                <v-radio label="E-mail" value="E-MAIL"></v-radio>
                <v-radio label="Telefone" value="TELEFONE"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Nome Favorecido Pix" outlined dense hide-details v-model="solicitacaoResgate.favorecidoPix"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Chave Pix" outlined dense hide-details v-model="solicitacaoResgate.chavePix"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialogoDadosResgate = false">Fechar</v-btn>
          <v-btn text color="primary" @click="solicitarResgate">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoInformacoes" max-width="1000px" scrollable>
      <v-card>
        <v-card-title>Seu ingresso é também o seu cartão de consumo!</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <p>Estamos felizes em apresentar o Cartão de Consumo como uma solução prática e eficiente para tornar sua experiência no evento ainda mais agradável. Faça sua recarga antecipada e evite filas no dia do evento! Confira abaixo as vantagens de utilizar nosso Cartão de Consumo e recarregar com antecedência:</p>
          <p>
            <ul>
              <li style="margin-bottom: 10px">Evite filas no dia do evento: Realize sua recarga antecipada e economize tempo no dia do evento, evitando filas e atrasos. Com o crédito já disponível no seu cartão, você poderá curtir o evento sem preocupações.</li>
              <li style="margin-bottom: 10px">Praticidade e segurança: O Cartão de Consumo oferece uma maneira prática e segura de realizar compras no evento, eliminando a necessidade de levar dinheiro ou outros meios de pagamento além de facilitar o troco.</li>
              <li style="margin-bottom: 10px">Resgate de saldo não utilizado: Caso você não gaste todo o valor recarregado no seu cartão, não se preocupe! O saldo remanescente poderá ser resgatado via PIX, garantindo que você não perca seu dinheiro.</li>
              <li style="margin-bottom: 10px">Créditos que não expiram: Os créditos adquiridos no Cartão de Consumo não têm data de validade, o que significa que você pode usá-los em outros eventos futuros que utilizem o mesmo sistema.</li>
              <li style="margin-bottom: 10px">Controle de gastos e notificações via WhatsApp: Com o Cartão de Consumo, você tem um controle maior sobre seus gastos no evento, já que é possível acompanhar o saldo e as transações realizadas. Além disso, você receberá informações sobre recargas e compras diretamente no seu WhatsApp, facilitando ainda mais o controle e a organização dos seus gastos.</li>
            </ul>
          </p>
          <p>Exemplos de utilização do Cartão de Consumo:</p>
          <p>
            <ul>
              <li style="margin-bottom: 10px">Fazer um lanche: Aproveite as delícias oferecidas nos pontos de alimentação do evento.</li>
              <li style="margin-bottom: 10px">Comprar livros: Adquira obras literárias dos preletores.</li>
              <li>Adquirir blusas e acessórios, entre outros: O Cartão de Consumo pode ser utilizado em diversas atividades e estabelecimentos dentro do evento, proporcionando praticidade e comodidade para aproveitar ao máximo sua experiência.</li>
            </ul>
          </p>
          <p>Não perca a oportunidade de desfrutar de todas essas vantagens! Faça sua recarga antecipada e aproveite ao máximo a experiência no evento. Estamos ansiosos para proporcionar momentos incríveis e inesquecíveis a todos os participantes!</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialogoInformacoes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoValorTransacao" persistent max-width="400px">
      <v-card rounded="lg">
        <v-toolbar flat color="#4CAF50" dark>
          <v-icon left>mdi-cash-plus</v-icon>
          <v-toolbar-title>Recarga via PIX</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pa-4 mt-2">
          <v-row>
            <v-col cols="12">
              <p class="subtitle-1 font-weight-medium">Informe o valor que deseja recarregar</p>
              <p class="caption text-grey-darken-1 mb-4">Valor mínimo para recargas: R$1,00</p>
              <v-text-field
                label="Valor da recarga"
                outlined
                v-model="valorTransacao"
                hide-details
                v-money="money"
                prefix="R$"
                type="tel"
                color="#4CAF50"
                class="mt-2"
                id="campoValor"
                autofocus
                :background-color="valorTransacao && parseFloat(valorTransacao.replace(',','.')) >= 1 ? '#f5fbf5' : ''"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-btn text color="grey darken-1" @click="dialogoValorTransacao = false" depressed>
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            depressed 
            class="px-5" 
            :disabled="valorTransacao == '0,00' || parseFloat(valorTransacao.replace(',','.')) < 1"
            v-if="tipoTransacao == 'PIX'" 
            @click="abreLeituraQRCode('DEPÓSITO', 'PIX')"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            Continuar
          </v-btn>
          <v-btn 
            color="primary" 
            depressed 
            class="px-5" 
            :disabled="valorTransacao == '0,00' || parseFloat(valorTransacao.replace(',','.')) < 1"
            v-if="tipoTransacao == 'CARTÃO'" 
            @click="abreLeituraQRCode('DEPÓSITO', 'CARTÃO')"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoTaxaCartao" persistent max-width="400px">
      <v-card>
        <v-card-title>Atenção</v-card-title>
        <v-card-text>
          <p style="margin: 0px">Será descontada uma taxa de {{ taxaRecargaCartao }}% sobre o valor de recarga. Para recarregar sem taxas, utilize a opção Pix.</p>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col cols="12">
              <v-btn color="primary" @click="continuarPagamentoCartao" block>Continuar com Cartão</v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn color="success" @click="fechaDialogoTaxa" block >Pagar com Pix</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoTabelaHistorico" persistent max-width="600px" scrollable>
      <v-card>
        <v-toolbar color="#1565C0" dark>
          <v-toolbar-title class="font-weight-medium">
            <v-icon left>mdi-history</v-icon>
            Histórico de Transações
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogoTabelaHistorico = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text class="pa-0">
          <!-- Lista de transações vazia -->
          <div class="pa-4" v-if="!filteredTransactions.length">
            <v-alert
              type="info"
              outlined
              dense
              icon="mdi-information"
            >
              Nenhuma transação encontrada.
            </v-alert>
          </div>
          
          <!-- Lista de transações - versão minimalista estilo extrato bancário -->
          <v-list class="transaction-list pa-0" v-if="filteredTransactions.length">
            <!-- Cabeçalho -->
            <v-list-item class="transaction-header grey lighten-4">
              <v-list-item-content class="py-1">
                <div class="d-flex">
                  <div style="width: 30%;" class="text-caption font-weight-medium">Data/Hora</div>
                  <div style="width: 40%;" class="text-caption font-weight-medium">Descrição</div>
                  <div style="width: 30%;" class="text-caption font-weight-medium text-right">Valor</div>
                </div>
              </v-list-item-content>
                  </v-list-item>
            
                <v-divider></v-divider>
            
            <!-- Itens do extrato agrupados por mês -->
            <div v-for="(group, groupIndex) in groupedTransactions" :key="'group-'+groupIndex">
              <!-- Separador de mês -->
              <v-subheader v-if="groupIndex > 0" class="grey lighten-3 month-divider">
                {{ getMesCompleto(group.month) }} / {{ group.year }}
              </v-subheader>
              
              <!-- Itens do mês -->
              <div v-for="(item, index) in group.items" :key="'item-'+group.month+'-'+index">
                <v-list-item 
                  @click="exibeDetalhes(item)"
                  class="transaction-item"
                  :class="{'grey lighten-5': index % 2 === 0}"
                >
                  <v-list-item-content class="py-2">
                    <div class="d-flex align-center">
                      <!-- Data -->
                      <div style="width: 30%;" class="d-flex align-center">
                        <div class="date-container">
                          <div class="date-day">{{ formatDateTime(item.created).split('/')[0] }}</div>
                          <div class="date-month text-caption grey--text">{{ getMesAbreviado(formatDateTime(item.created).split('/')[1]) }}</div>
                        </div>
                        <div class="date-time text-caption ml-2 grey--text">
                          {{ formatDateTime(item.created).split(' · ')[1] }}
                        </div>
                      </div>
                      
                      <!-- Descrição -->
                      <div style="width: 40%;" class="text-body-2 d-flex align-center">
                        <v-icon 
                          :color="getTransactionColor(item.tipoTransacao, item.statusPagamento)" 
                          size="18" 
                          class="mr-2"
                        >
                          {{ getTransactionIcon(item.tipoTransacao, item.statusPagamento) }}
                        </v-icon>
                        <div class="d-flex flex-column">
                          <span>{{ getTransactionTitle(item) }}</span>
                          <span
                            v-if="isAdminTransaction(item) && getAdminCounterparty(item)"
                            class="text-caption grey--text text-truncate"
                            style="max-width: 220px;"
                          >
                            {{ getAdminCounterparty(item) }}
                          </span>
                          <span
                            v-if="isAdminTransaction(item) && getAdminReason(item)"
                            class="text-caption grey--text text-truncate"
                            style="max-width: 220px;"
                          >
                            Motivo: {{ getAdminReason(item) }}
                          </span>
                        </div>
                      </div>
                      
                      <!-- Valor -->
                      <div 
                        style="width: 30%;" 
                        :class="[
                          'text-body-2 font-weight-medium text-right', 
                          item.tipoTransacao === 'DEPÓSITO' && item.statusPagamento !== 'PENDENTE' ? 'success--text' : 
                          item.tipoTransacao === 'DEPÓSITO' && item.statusPagamento === 'PENDENTE' ? 'warning--text' : 
                          'error--text'
                        ]"
                      >
                        <template v-if="item.tipoTransacao === 'DEPÓSITO' && item.statusPagamento === 'PENDENTE'">
                          <v-icon small color="warning" class="mr-1">mdi-clock-outline</v-icon>R$ {{ item.valor }} (Pendente)
            </template>
                        <template v-else>
                          {{ item.tipoTransacao === 'DEPÓSITO' ? '+' : '-' }}R$ {{ item.valor }}
                        </template>
                      </div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index < group.items.length - 1"></v-divider>
              </div>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoDetalhesConsumo" persistent max-width="500px" scrollable>
      <v-card>
        <v-toolbar :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)" dark>
          <v-toolbar-title>
            <v-icon left>{{ getTransactionIcon(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento) }}</v-icon>
            {{ getTransactionTitle(detalhesCompra) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogoDetalhesConsumo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text class="pt-4">
          <!-- Cabeçalho com data, hora e valor -->
          <div class="d-flex justify-space-between align-center mb-4">
            <div class="text-subtitle-1">
              {{ formatDateTime(detalhesCompra.created) }}
            </div>
            <div :class="[
              'text-h5 font-weight-bold', 
              detalhesCompra.tipoTransacao === 'DEPÓSITO' && detalhesCompra.statusPagamento !== 'PENDENTE' ? 'success--text' : 
              detalhesCompra.tipoTransacao === 'DEPÓSITO' && detalhesCompra.statusPagamento === 'PENDENTE' ? 'warning--text' : 
              'error--text'
            ]">
              <template v-if="detalhesCompra.tipoTransacao === 'DEPÓSITO' && detalhesCompra.statusPagamento === 'PENDENTE'">
                <v-icon small color="warning" class="mr-1">mdi-clock-outline</v-icon>
                R$ {{ detalhesCompra.valor }} (Pendente)
              </template>
              <template v-else>
                {{ detalhesCompra.tipoTransacao === 'DEPÓSITO' ? '+' : '-' }}R$ {{ detalhesCompra.valor }}
              </template>
            </div>
          </div>
          
          <!-- Divider -->
          <v-divider class="mb-4"></v-divider>
          
          <!-- Informações da transação -->
          <v-list dense class="pa-0 transparent">
            <!-- Local da transação -->
            <v-list-item v-if="detalhesCompra.lojista" class="px-0">
              <v-list-item-icon class="mr-2">
                <v-icon :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)">mdi-store</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-body-2">Local</v-list-item-subtitle>
                <v-list-item-title>{{ detalhesCompra.lojista.nome }}</v-list-item-title>
                  </v-list-item-content>
            </v-list-item>
            
            <!-- Atendente -->
            <v-list-item v-if="detalhesCompra.atendente || detalhesCompra.tipoTransacao === 'CONSUMO'" class="px-0">
              <v-list-item-icon class="mr-2">
                <v-icon :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-body-2">Atendido por</v-list-item-subtitle>
                <v-list-item-title>{{ detalhesCompra.atendente ? detalhesCompra.atendente.nome : 'Autoatendimento' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <!-- Método de pagamento (para DEPÓSITO) -->
            <v-list-item
              v-if="detalhesCompra.tipoTransacao === 'DEPÓSITO' && detalhesCompra.formaTransacao && !isAdminTransaction(detalhesCompra)"
              class="px-0"
            >
              <v-list-item-icon class="mr-2">
                <v-icon :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)">
                  {{ detalhesCompra.formaTransacao === 'PIX' ? 'mdi-contactless-payment' : 
                     detalhesCompra.formaTransacao === 'CARTAO' ? 'mdi-credit-card' : 'mdi-cash' }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-body-2">Método de pagamento</v-list-item-subtitle>
                <v-list-item-title>{{ detalhesCompra.formaTransacao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <!-- Status de pagamento (para DEPÓSITO) -->
            <v-list-item v-if="detalhesCompra.tipoTransacao === 'DEPÓSITO'" class="px-0">
              <v-list-item-icon class="mr-2">
                <v-icon :color="detalhesCompra.statusPagamento === 'PENDENTE' ? 'warning' : 'success'">
                  {{ detalhesCompra.statusPagamento === 'PENDENTE' ? 'mdi-clock-outline' : 'mdi-check-circle-outline' }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-body-2">Status do pagamento</v-list-item-subtitle>
                <v-list-item-title :class="detalhesCompra.statusPagamento === 'PENDENTE' ? 'warning--text' : ''">
                  {{ detalhesCompra.statusPagamento === 'PENDENTE' ? 'Aguardando pagamento' : 'Pagamento confirmado' }}
                </v-list-item-title>
              </v-list-item-content>
                </v-list-item>
            <v-list-item v-if="isAdminTransaction(detalhesCompra)" class="px-0">
              <v-list-item-icon class="mr-2">
                <v-icon :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)">mdi-shield-account-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-body-2">Lançamento</v-list-item-subtitle>
                <v-list-item-title>{{ getTransactionTitle(detalhesCompra) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="isAdminTransaction(detalhesCompra) && getAdminCounterparty(detalhesCompra)"
              class="px-0"
            >
              <v-list-item-icon class="mr-2">
                <v-icon :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)">mdi-account-switch-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-body-2">Aluno relacionado</v-list-item-subtitle>
                <v-list-item-title>{{ getAdminCounterparty(detalhesCompra) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="isAdminTransaction(detalhesCompra) && getAdminReason(detalhesCompra)"
              class="px-0"
            >
              <v-list-item-icon class="mr-2">
                <v-icon :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)">mdi-note-text-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="text-body-2">Motivo</v-list-item-subtitle>
                <v-list-item-title>{{ getAdminReason(detalhesCompra) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
              </v-list>
          
          <!-- Itens do consumo (somente para tipo CONSUMO) -->
          <template v-if="detalhesCompra.tipoTransacao === 'CONSUMO' && detalhesCompra.itens && detalhesCompra.itens.length > 0">
            <v-subheader class="pl-0 mt-2">
              <v-icon :color="getTransactionColor(detalhesCompra.tipoTransacao, detalhesCompra.statusPagamento)" class="mr-2">mdi-cart-outline</v-icon>
              Itens da compra
            </v-subheader>
            
            <v-list dense>
              <v-list-item v-for="(item, index) in detalhesCompra.itens" :key="index" class="px-2">
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ item.quantidade || 1 }}x {{ item.descricao || 'Item' }}
                  </v-list-item-title>
                  </v-list-item-content>
                <v-list-item-action class="my-0">
                  <span class="success--text font-weight-medium">
                    R$ {{ (parseFloat(item.preco.replace(',','.')) * (item.quantidade || 1)).toFixed(2).replace('.',',') }}
                  </span>
                </v-list-item-action>
              </v-list-item>
              
              <v-divider></v-divider>
              
              <v-list-item class="px-2">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">Total</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <span class="font-weight-bold success--text">
                    R$ {{ detalhesCompra.valor }}
                  </span>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
          </template>
        </v-card-text>
        
        <v-divider></v-divider>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#1565C0" @click="dialogoDetalhesConsumo = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoCartaoConsumoVirtual" persistent max-width="400px">
      <v-card :img="require('../assets/fundoBranco.png')">
        <v-card-text style="padding-top: 15px; padding-bottom: 15px; background: linear-gradient(to bottom, #132651, #3279CC);">
          <v-row dense>
            <!-- <v-col cols="12" class="login-title">
              <img src="../assets/logoConsumerBranca.png" width="100%" style="max-width: 150px">
            </v-col> -->
            <v-col cols="9" class="login-title">
              <v-card flat style="padding: 10px">
                <qrcode-vue :value="codigoInscricao" :size="200" level="H"></qrcode-vue>
                <p style="margin: 0px"><b>{{ codigoInscricao.substring(codigoInscricao.length, codigoInscricao.length - 6) }}</b></p>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogoCartaoConsumoVirtual = false" color="red" text>Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoItensBloqueados" persistent max-width="600px" scrollable>
      <v-card>
        <v-toolbar dark color="#073478" flat>
          <v-toolbar-title>Bloqueio de Itens</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="dialogoItensBloqueados = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-alert
            dense
            text
            color="info"
            class="mb-4"
          >
            Ative para permitir o consumo do item, desative para bloquear
          </v-alert>

          <v-list dense>
            <div v-for="item in produtos" :key="item.id">
              <v-list-item>
                <v-list-item-avatar size="40">
                  <v-img v-if="item.urlImagem" :src="item.urlImagem"></v-img>
                  <v-icon v-else color="grey">mdi-food</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ item.descricao }}
                  </v-list-item-title>

                  <v-list-item-subtitle v-if="!item.permitido">
                    {{ resumoDias(item) }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-switch
                    v-model="item.permitido"
                    color="success"
                    inset
                    :loading="item.salvando"
                    @change="salvarBloqueioItem(item)"
                  />
                </v-list-item-action>
              </v-list-item>

              <v-expand-transition>
                <div v-if="!item.permitido" class="pl-2 pr-2 pb-6">
                  <v-row dense>
                    <v-col
                      v-for="dia in diasSemana"
                      :key="dia.value"
                      cols="4"
                      sm="auto"
                      style="margin: 0 auto"
                    >
                      <v-chip
                        @click="toggleDia(item, dia.value)"
                        :outlined="item.diasPermitidos[dia.value]"
                        :color="item.diasPermitidos[dia.value] ? 'red' : 'green'"
                        class="dia-chip"
                        label
                      >
                      {{ dia.label }}
                      <v-icon right small>{{ item.diasPermitidos[dia.value] ? 'mdi-close' : 'mdi-check' }}</v-icon>
                      </v-chip>
                    </v-col>
                  </v-row>
                </div>
              </v-expand-transition>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="dialogoRodapeConfiguracoes" inset>
      <v-sheet>
        <v-toolbar flat dense>
          <v-toolbar-title>Configurações</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogoRodapeConfiguracoes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list>
          <v-list-item @click="dialogoItensBloqueados = true; dialogoRodapeConfiguracoes = false">
            <v-list-item-icon>
              <v-icon>mdi-cancel</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Itens bloqueados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="dialogoAlterarDadosCadastrais = true; dialogoRodapeConfiguracoes = false">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Dados cadastrais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="dialogoAlterarSenha = true; dialogoRodapeConfiguracoes = false">
            <v-list-item-icon>
              <v-icon>mdi-key</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Alterar senha</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-credit-card</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cartão ativo</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-switch inset v-model="cartaoAtivo" @change="handleCartaoSwitchChange"></v-switch>
            </v-list-item-action>
          </v-list-item>

          <v-list-item @click="dialogoLimiteCartao = true; dialogoRodapeConfiguracoes = false">
            <v-list-item-icon>
              <v-icon>mdi-credit-card-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ tipoLimiteDiario }}</v-list-item-title>
              <v-list-item-subtitle v-if="consumidor.limiteDiarioConsumo">Atualmente, o limite definido é R$ {{ retornaValorFormatado(consumidor.limiteDiarioConsumo) }}.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-bottom-sheet>

    <v-dialog v-model="dialogoCartaoConfig" persistent max-width="450px">
  <v-card>
    <v-toolbar dark color="#01579B" class="elevation-0">
      <v-icon left>mdi-credit-card-check</v-icon>
      <v-toolbar-title>Bloqueio de Cartão</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="cancelarAlteracaoCartao">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" v-if="consumidorId">
          <p style="margin: 0px">ID do usuário</p>
          <v-text-field v-model="consumidorId" label="ID do usuário" type="text" readonly></v-text-field>
        </v-col>
        <v-col cols="12">
          <p style="margin: 0px">Senha</p>
          <v-text-field v-model="senha" label="Digite sua senha" type="password" required></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="red" @click="cancelarAlteracaoCartao">Cancelar</v-btn>
      <v-btn text color="green" @click="alterarSituacaoCartao">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
      
    <v-dialog v-model="dialogoAlterarSenha" persistent max-width="500px">
      <v-card>
        <v-card-title>Alterar senha</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <p style="margin: 0px">Senha atual</p>
              <v-otp-input v-model="pinAntigo" length="4" type="number"></v-otp-input>
            </v-col>
            <v-col cols="12">
              <p style="margin: 0px">Nova senha</p>
              <v-otp-input v-model="pinNovo" length="4" type="number"></v-otp-input>
            </v-col>
            <v-col cols="12">
              <p style="margin: 0px">Repita a nova senha</p>
              <v-otp-input v-model="confirmacaoPin" length="4" type="number"></v-otp-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialogoAlterarSenha = false">Fechar</v-btn>
          <v-btn text color="green" @click="alterarSenha">Alterar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoAlterarDadosCadastrais" persistent max-width="450px">
      <v-card>
        <v-toolbar dark color="#01579B" class="elevation-0">
          <v-icon left>mdi-account-edit</v-icon>
          <v-toolbar-title>Dados Cadastrais</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogoAlterarDadosCadastrais = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text class="pa-4">
          <v-alert
                dense
            text
            color="primary"
            class="mb-4"
          >
            <v-icon size="18" class="mr-2">mdi-information-outline</v-icon>
            Mantenha seus dados sempre atualizados.
          </v-alert>
          
          <!-- Área da foto do aluno -->
          <div v-if="dadosCadastrais.hashBase64 || consumidor.foto" class="text-center mb-4">
            <v-avatar size="120" class="elevation-2">
              <v-img :src="dadosCadastrais.hashBase64 || consumidor.foto" alt="Foto do aluno"></v-img>
            </v-avatar>
            <div class="mt-2">
              <v-btn small text color="primary" @click="dialogoCamera = true">
                <v-icon small left>mdi-camera</v-icon>
                Alterar foto
              </v-btn>
            </div>
          </div>
          <div v-else class="text-center mb-4">
            <v-avatar size="120" class="elevation-2 grey lighten-3">
              <v-icon size="64" color="grey darken-2">mdi-account</v-icon>
            </v-avatar>
            <div class="mt-2">
              <v-btn small text color="primary" @click="dialogoCamera = true">
                <v-icon small left>mdi-camera</v-icon>
                Adicionar foto
              </v-btn>
            </div>
          </div>
          
          <v-form ref="formDadosCadastrais" class="campos-form">
            <v-text-field
                v-model="dadosCadastrais.cpf"
                v-validate="'required|cpf'"
                :error-messages="errors.collect('cpf')"
                data-vv-name="cpf"
              label="CPF"
              prepend-icon="mdi-card-account-details-outline"
                type="tel"
                v-mask="'###.###.###-##'"
                outlined
                dense
              color="#01579B"
              class="mb-1"
              ></v-text-field>
            
              <v-text-field
              v-model="dadosCadastrais.nome"
              label="Nome completo"
              prepend-icon="mdi-account"
                outlined
                dense
              color="#01579B"
              class="mb-1"
              ></v-text-field>
            
              <v-text-field
              v-model="dadosCadastrais.dataNascimento"
                label="Data de nascimento"
              v-mask="'##/##/####'"
              prepend-icon="mdi-calendar"
                outlined
                dense
              color="#01579B"
              class="mb-1"
              ></v-text-field>
            
              <v-text-field
              v-model="dadosCadastrais.turma"
                label="Turma"
              prepend-icon="mdi-account-group"
                outlined
                dense
              color="#01579B"
              class="mb-1"
              ></v-text-field>
            
              <v-text-field
              v-model="dadosCadastrais.responsavel"
                label="Responsável"
              prepend-icon="mdi-account-supervisor"
                outlined
                dense
              color="#01579B"
              class="mb-1"
              ></v-text-field>
            
            <v-text-field
              v-model="dadosCadastrais.whatsApp"
              label="WhatsApp"
              v-mask="'(##) #####-####'"
              prepend-icon="mdi-phone"
              outlined
              dense
              color="#01579B"
              hint="Receberá notificações neste número"
              persistent-hint
              class="mb-1"
            ></v-text-field>
          </v-form>
        </v-card-text>
        
        <v-card-actions class="pa-4 pt-2">
          <v-spacer></v-spacer>
          <v-btn 
            text 
            color="grey darken-1" 
            @click="dialogoAlterarDadosCadastrais = false"
          >
            CANCELAR
          </v-btn>
          <v-btn 
            color="#01579B" 
            dark 
            @click="alterarDadosCadastrais"
            min-width="120"
          >
            SALVAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <loading :active.sync="isLoading" :can-cancel="true" color="#474d55" :is-full-page="fullPage"></loading>
  <Snackbar ref=chamaSnackbar />
  <v-snackbar v-model="snackbar" :timeout="timeout">
    {{ textoSnackbar }}
    <template v-slot:action="{ attrs }">
      <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
    </template>
  </v-snackbar>

  <!-- Diálogo da câmera para captura de foto -->
  <v-dialog v-model="dialogoCamera" max-width="500px">
    <v-card>
      <v-card-title style="padding: 5px 15px 5px 15px">
        Câmera
        <v-spacer></v-spacer>
        <v-btn @click="dialogoCamera = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title><v-card-text style="padding: 0px 7px 0px 7px">
        <v-alert type="info" dense text outlined>Capture ou selecione uma foto com rosto visível e claro.</v-alert>
      </v-card-text>
      <v-card-text style="padding: 0px 7px 0px 7px">
        <CameraView
          ref="camera"
          :ativo="dialogoCamera"
          @cameras-detectadas="totalCameras = $event"
        />

        <div class="d-flex justify-center align-center pa-3">
          <div class="text-center mx-4" v-if="totalCameras > 1">
            <v-btn
              @click="$refs.camera.alternarCamera()"
              fab
              color="primary"
              depressed
            >
              <v-icon large>mdi-camera-flip</v-icon>
            </v-btn>
            <div class="caption">Alternar</div>
          </div>
          <div class="text-center mx-4">
            <v-btn @click="capturarFoto" depressed fab color="primary" class="mb-1">
              <v-icon large>mdi-camera-iris</v-icon>
            </v-btn>
            <div class="caption">Capturar</div>
          </div>
          <div class="text-center mx-4">
            <file-upload
              class="d-inline-block"
              input-id="foto-upload"
              extensions="png,gif,jpeg,jpg"
              accept="image/png,image/gif,image/jpeg,image/jpg"
              v-model="files"
              @input-filter="inputFilter"
              @input-file="inputFile"
            >
              <v-btn fab outlined color="primary" >
                <v-icon large>mdi-file-upload</v-icon>
              </v-btn>
            </file-upload>
            <div class="caption">Galeria</div>
          </div>
          <p id="foto" value="" hidden></p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

    <v-dialog v-model="dialogoLimiteCartao" persistent max-width="400px">
      <v-card>
        <v-card-title>{{ tipoLimiteDiario }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <p style="margin: 0px">Valor para limite diário. Deixe-o R$ 0,00 para sem limite.</p>
              <v-text-field
                outlined
                v-model="valorLimiteCartao"
                hide-details
                v-money="money"
                prefix="R$"
                type="tel"
                color="#4CAF50"
                class="mt-2"
                id="campoValorLimiteCartao"
                autofocus
                :background-color="valorLimiteCartao && parseFloat(valorLimiteCartao.replace(',','.')) >= 1 ? '#f5fbf5' : ''"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialogoLimiteCartao = false">Fechar</v-btn>
          <v-btn text color="green" @click="definirLimiteCartao">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import axios from 'axios'
  import { VMoney } from 'v-money'
  import moment from 'moment'
  import QrcodeVue from 'qrcode.vue'
  import CpfValidate from '../componentes/validators/rules/cpf'
  import FileUpload from 'vue-upload-component'
  import CameraView from '../componentes/CameraView.vue'
  export default {
    components: { Snackbar, Loading, QrcodeVue, FileUpload, CameraView, },
    name: 'Caixa',
    data() {
      return {
        login: {},
        show1: false,
        usuarioLogado: false,
        loadingBotao: false,
        recuperaSenha: false,
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        side: 1,
        pinTransacao: '',
        valorTransacao: '0,00',
        tipoTransacao: '',
        formaTransacao: '',
        codigoQrCode: '',
        codigoInscricao: '',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        consumidor: {
          nome: '',
          cpf: '',
          whatsApp: '',
          qrCode: '',
          produtosBloqueados: [],
        },
        empresa: {
          logo: '',
          gatewayPagamentoPix: '',
        },
        fullPage: true,
        isLoading: false,
        respostaTransacao: [],
        mesesVencimento: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        anosVencimento: [],
        bandeiras: [
          { value: 'DINERS', text: "DINERS" },
          { value: 'ELO', text: "ELO" },
          { value: 'HIPERCARD', text: "HIPERCARD" },
          { value: 'MASTERCARD', text: "MASTERCARD" },
          { value: 'VISA', text: "VISA" },
        ],
        cobrancaAsaas: {
          customer: '',
          billingType: 'PIX',
          value: 0,
          dueDate: '',
          description: ''
        },
        cobrancaAsaasCartao: {
          customer: '',
          billingType: 'CREDIT_CARD',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        defaultCobrancaAsaas: {
          customer: '',
          billingType: 'PIX',
          value: 0,
          dueDate: '',
          description: ''
        },
        defaultCobrancaAsaasCartao: {
          customer: '',
          billingType: 'CREDIT_CARD',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        cobrancaPix: {
          id: '',
          qrCode: '',
          chaveCopiaCola: '',
        },
        solicitacaoResgate: {
          cpfConsumidor: '',
          qrCodeCartaoConsumo: '',
          tipoChavePix: '',
          chavePix: '',
          favorecidoPix: '',
        },
        exibirQRCode: false,
        audio: '',
        dialogoSolicitaPin: false,
        dialogoCaptura: false,
        dialogoCadastraConsumidor: false,
        dialogoOperacao: false,
        dialogoCartao: false,
        dialogoPagamentoPix: false,
        dialogoConfirmacao: false,
        verificaPagamento: '',
        saldoCartao: '',
        dialogoConsultaSaldo: false,
        dialogoSolicitaResgate: false,
        dialogoDadosResgate: false,
        dialogoInformacoes: false,
        dialogoValorTransacao: false,
        dialogoTaxaCartao: false,
        tipoCodigoUrl: '',
        tabela: {
          busca: '',
          conteudo: [],
        },
        dialogoHistoricoConsumo: false,
        dialogoTabelaHistorico: false,
        dialogoDetalhesConsumo: false,
        detalhesCompra: {
          tipoTransacao: "CONSUMO",
          valor: "",
          "lojista": {
            "nome": "Pastel da Liberdade",
          },
          "atendente": {
            "nome": "Pastel 1",
          }
        },
        taxaRecargaCartao: 0,
        dialogoCartaoConsumoVirtual: false,
        valorCartaoConsumo: '',
        exibeSaldoCartaoConsumo: true,
        exibeCardapioEvento: '',
        matriculaRules: [
          v => !!v || 'Matrícula é obrigatório'
        ],
        passwordRules: [
          v => !!v || 'Senha é obrigatório'
        ],
        urlOrigem: '',
        dialogoItensBloqueados: false,
        dialogoConfirmaBloqueados: false,
        produtos: [],
        selecaoBloqueados: [],
        virtualScrollKey: 0,
        dialogoRodapeConfiguracoes: false,
        dialogoCartaoConfig: false,
        estadoSwitchOriginal: true,
        estadoSwitchTemp: true,
        cartaoAtivo: true,
         id: '',          
         senha: '', 
         consumidorId: '',
        dialogoAlterarSenha: false,
        pinAntigo: "",
        pinNovo: "",
        confirmacaoPin: "",
        dialogoAlterarDadosCadastrais: false,
        dadosCadastrais: {
          cpf: '',
          nome: '',
          whatsApp: '',
          dataNascimento: '',
          turma: '',
          responsavel: '',
          consumidorId: '',
          foto: '',
          hashBase64: '',
        },
        files: [],
        dialogoCamera: false,
        totalCameras: 1,
        dialogoLimiteCartao: false,
        valorLimiteCartao: '0,00',
        diasSemana: [
          { label: 'Dom', value: 'domingo' },
          { label: 'Seg', value: 'segunda' },
          { label: 'Ter', value: 'terça' },
          { label: 'Qua', value: 'quarta' },
          { label: 'Qui', value: 'quinta' },
          { label: 'Sex', value: 'sexta' },
          { label: 'Sab', value: 'sabado' }
        ],
      }
    },

    watch: {
      dialogoSolicitaPin() {
        if (this.dialogoSolicitaPin == true) {
          setTimeout(() => {
            document.getElementById('pinTransacao--0').focus()
          }, 400);
        }
      },

      dialogoOperacao() {
        if (this.dialogoOperacao == false) {
          this.respostaTransacao = []
        }
      },

      dialogoPagamentoPix() {
        if (this.dialogoPagamentoPix == false) {
          this.cobrancaAsaas = Object.assign({}, this.defaultCobrancaAsaas)
          clearInterval(this.verificaPagamento)
          document.getElementById('campoValor').value = '0,00'
        }
      },

      dialogoCartao() {
        if (this.dialogoCartao == false) {
          this.cobrancaAsaasCartao = Object.assign({}, this.defaultCobrancaAsaasCartao)
          document.getElementById('campoValor').value = '0,00'
        }
      },

      dialogoCadastraConsumidor() {
        if (this.dialogoCadastraConsumidor == false) {
          this.consumidor.nome = ''
          this.consumidor.whatsApp = ''
          this.consumidor.cpf = ''
          this.tecladoCPFConsumidor = false
          this.tecladoNomeConsumidor = false
          this.tecladoWhatsAppConsumidor = false
          document.getElementById('campoValor').value = '0,00'
        }
      },

      dialogoDadosResgate() {
        if (this.dialogoDadosResgate == false) {
          this.solicitacaoResgate.cpfConsumidor = ''
          this.solicitacaoResgate.qrCodeCartaoConsumo = ''
          this.solicitacaoResgate.tipoChavePix = ''
          this.solicitacaoResgate.chavePix = ''
        }
      },

      dialogoItensBloqueados() {
        if (this.dialogoItensBloqueados == false) {
          this.produtos = []
          this.selecaoBloqueados = []
        } else {
          this.carregaProdutos()
        }
      },

      dialogoAlterarSenha() {
        if (this.dialogoAlterarSenha == false) {
          this.pinAntigo = ''
          this.pinNovo = ''
          this.confirmacaoPin = ''
        }
      },

      dialogoAlterarDadosCadastrais() {
        if (this.dialogoAlterarDadosCadastrais == true) {
          this.dadosCadastrais.cpf = this.consumidor.cpf
          this.dadosCadastrais.nome = this.consumidor.nome
          this.dadosCadastrais.whatsApp = this.consumidor.whatsApp
          this.dadosCadastrais.dataNascimento = this.consumidor.dataNascimento
          this.dadosCadastrais.turma = this.consumidor.turma
          this.dadosCadastrais.responsavel = this.consumidor.responsavel
          this.dadosCadastrais.consumidorId = this.consumidor.id
          this.dadosCadastrais.foto = this.consumidor.foto
        } else {
          this.dadosCadastrais.cpf = ''
          this.dadosCadastrais.nome = ''
          this.dadosCadastrais.whatsApp = ''
          this.dadosCadastrais.dataNascimento = ''
          this.dadosCadastrais.turma = ''
          this.dadosCadastrais.responsavel = ''
          this.dadosCadastrais.consumidorId = ''
          this.dadosCadastrais.foto = ''
        }
      },

      dialogoCamera(val) {
        if (val == true) {
          //
        } else {
          //
        }
      },

      dialogoLimiteCartao(val) {
        if (val) {
          setTimeout(() => {
            this.valorLimiteCartao = this.retornaValorFormatado(this.consumidor.limiteDiarioConsumo)
            document.getElementById('campoValorLimiteCartao').value = this.retornaValorFormatado(this.consumidor.limiteDiarioConsumo)
          }, 100);
        }
        else {
          setTimeout(() => {
            this.valorLimiteCartao = '0,00'
            document.getElementById('campoValorLimiteCartao').value = '0,00'
          }, 100);
        }
      },
    },

    computed: {
      ...mapState({
        usuarioadmin: (state) => state.Userpermission,
        usuarioLogado: (state) => state.isMenuVisible,
        user: (state) => state.userObj,
        companyobj: (state) => state.companyObj,
      }),

      filteredTransactions() {
        if (!this.tabela.conteudo) return [];
        return this.tabela.conteudo;
      },

      groupedTransactions() {
        if (!this.filteredTransactions) return [];
        return this.groupTransactionsByMonth(this.filteredTransactions);
      },

      tipoLimiteDiario() {
        return this.consumidor.limiteDiarioConsumo ? 'Alterar limite diário' : 'Definir limite diário'
      },
    },

    async mounted() {
      this.audio = new Audio(require("../assets/beep.mp3"))
      this.pegaParametrosUrl()
      this.pegaConfiguracoes()

      if (localStorage.getItem("consumidor") && localStorage.getItem('empresa')) {
        this.consumidor = JSON.parse(localStorage.getItem("consumidor"))

        if (!this.consumidor.produtosBloqueados) {
          this.consumidor.produtosBloqueados = []
        }

        this.empresa = JSON.parse(localStorage.getItem("empresa"))
        this.tipoCodigoUrl = 'cod'
        this.codigoInscricao = this.consumidor.qrCode
        this.valorCartaoConsumo = await this.validaQrCode(this.codigoInscricao, 'saldo')
        this.usuarioLogado = true
      }
    },

    beforeDestroy() {
      //
    },

      methods: {
      handleCartaoSwitchChange(value) {
       this.estadoSwitchTemp = value;
       this.dialogoCartaoConfig = true;
      },

      abrirModalDadosCadastrais() {
        this.dialogoAlterarDadosCadastrais = true;
        this.dialogoRodapeConfiguracoes = false;
      },

  async alterarSituacaoCartao() {
    var vm = this;
    if (!this.senha) {
      vm.$refs.chamaSnackbar.snack("red", "Senha não fornecida!");
      return;
    }
    try {
      const response = await axios.post(baseApiUrl + 'CartoesConsumo/bloquearCartao', {
        id: this.consumidor.id,  
        senha: this.senha     
      });
      if (response.data) {
        vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!");
        this.senha = '';
        this.cartaoAtivo = this.estadoSwitchTemp;
        this.dialogoCartaoConfig = false;  
      }
    } catch (error) {
      vm.$refs.chamaSnackbar.snack("red", "Erro ao atualizar cartão!");
      this.cartaoAtivo = this.estadoSwitchOriginal;
      this.dialogoCartaoConfig = false; 
      }
  },
     cancelarAlteracaoCartao() {
      this.cartaoAtivo = this.estadoSwitchOriginal;
      this.dialogoCartaoConfig = false;
  }, 
     
      async pegaConfiguracoes() {
        await axios.get(baseApiUrl + 'Configuracoes/findOne?filter={"fields":{"taxaRecargaCartao": true, "exibeCardapioEvento": true}}')
        .then(response => {
          if (response.data) {
            this.taxaRecargaCartao = response.data.taxaRecargaCartao
            this.exibeCardapioEvento = response.data.exibeCardapioEvento
          }
        })
      },

      goToCardapio() {
        if (this.codigoInscricao) {
          sessionStorage.setItem('qrCodeCartao', this.codigoInscricao)
          sessionStorage.setItem('empresaId', this.consumidor.empresaId)
        }
        this.$router.push({ path: '/cardapio' })
      },

      alteraValor(valor) {
        const valorAtual = parseFloat(this.valorTransacao.replace(',','.')) || 0;
        const novoValor = valorAtual + valor;
        this.valorTransacao = novoValor.toFixed(2).replace('.',',');
      },

      async abreLeituraQRCode(tipo, forma) {
        var vm = this;
        if (this.valorTransacao == '0,00') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe um valor para continuar!","ATENÇÃO")
        } else if (parseFloat(this.valorTransacao.replace(',','.')) < 1) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Valor mínimo para recargas é de R$ 1,00","ATENÇÃO")
        } else {
          this.tipoTransacao = tipo
          this.formaTransacao = forma
          this.dialogoValorTransacao = false

          if (this.codigoInscricao) {
            if (this.tipoCodigoUrl == 'cod') {
              if (forma == 'CARTÃO') {
                this.isLoading = false
                this.continuarPagamentoCartao()
              } else if (forma == 'PIX') {
                if (this.empresa.gatewayPagamentoPix == 'ASAAS') {
                  this.pagarPixAsaas()
                } else if (this.empresa.gatewayPagamentoPix == 'TAPAGO') {
                  this.pagarPixTaPago()
                } else if (this.empresa.gatewayPagamentoPix == 'SICOOB') {
                  this.pagarPixSicoob();
                }
              }
            } else if (this.tipoCodigoUrl == 'cf') {
              this.isLoading = true
              let resultado = await this.validaQrCode(this.codigoInscricao, 'resultado')

              if (resultado == 'SUCESSO') {
                if (forma == 'CARTÃO') {
                  this.isLoading = false
                  this.continuarPagamentoCartao()
                } else if (forma == 'PIX') {
                  if (this.empresa.gatewayPagamentoPix == 'ASAAS') {
                    this.pagarPixAsaas()
                  } else if (this.empresa.gatewayPagamentoPix == 'TAPAGO') {
                    this.pagarPixTaPago()
                  } else if (this.empresa.gatewayPagamentoPix == 'SICOOB') {
                    this.pagarPixSicoob();
                  }
                }
              } else if (resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
                this.isLoading = false
                this.dialogoCadastraConsumidor = true
              } else if (resultado == 'QRCODE_INVALIDO') {
                vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
              }

              //this.isLoading = false
            }
          } else {
            this.audio.play()
            this.dialogoCaptura = true
          }
        }
      },

      continuarPagamentoCartao() {
        this.dialogoCartao = true
        this.criarAnosVencimento()
        //this.dialogoTaxaCartao = false
      },

      consultarSaldo() {
        if (this.codigoInscricao) {
          this.fazerConsultaSaldo(this.codigoInscricao)
        } else {
          this.audio.play()
          this.dialogoConsultaSaldo = true
        }
      },

      solicitaResgate() {
        if (this.codigoInscricao) {
          this.fazerSolitacaoResgate(this.codigoInscricao)
        } else {
          this.audio.play()
          this.dialogoSolicitaResgate = true
        }
      },

      visualizarHistorico() {
        if (this.codigoInscricao) {
          this.fazerConsultaHistorico(this.codigoInscricao)
        } else {
          this.audio.play()
          this.dialogoHistoricoConsumo = true
        }
      },

      async solicitarResgate() {
        var vm = this

        if (!this.solicitacaoResgate.tipoChavePix || !this.solicitacaoResgate.favorecidoPix || !this.solicitacaoResgate.chavePix) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos","ATENÇÃO")
        } else {
          this.isLoading = true
          
          await axios.post(baseApiUrl + 'SolicitacoesResgates/cadastrarSolicitacao', this.solicitacaoResgate)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoDadosResgate = false
              if (response.data.resultado == 'SUCESSO') {
                vm.$refs.chamaSnackbar.snack("#0288D1","Sua solicitação de resgate no valor de R$ " + response.data.saldo + " para a chave Pix " + this.solicitacaoResgate.chavePix + " foi realizada. Aguarde até um dia útil para receber o valor. Caso haja consumação antes da conclusão do resgate, o valor será descontado.","ATENÇÃO")
              } else if (response.data.resultado == 'CPF_DIFERENTE_DO_CONSUMIDOR') {
                vm.$refs.chamaSnackbar.snack("#F9A825","CPF informado é diferente do consumidor","ATENÇÃO")
              } else if (response.data.resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
                vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
              } else if (response.data.resultado == 'SOLICITACAO_CADASTRADA_ANTERIORMENTE') {
                vm.$refs.chamaSnackbar.snack("#F9A825","Solicitação de resgate já cadastrada anteriormente. O prazo de conclusão é de até 72hrs após a solicitação.","ATENÇÃO")
              }
            }
          }).catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar solicitação de resgate, tente novamente","DESCULPE")
          })
        }
      },

      async decodificar(decodedString) {
        this.codigoQrCode = decodedString
        let verificacao = await this.validaQrCode(this.codigoQrCode, 'resultado')
        if (verificacao == 'SUCESSO') {
          if (this.formaTransacao == 'CARTÃO') {
            this.continuarPagamentoCartao()
          } else if (this.formaTransacao == 'PIX') {
            if (this.empresa.gatewayPagamentoPix == 'ASAAS') {
              this.pagarPixAsaas()
            } else if (this.empresa.gatewayPagamentoPix == 'TAPAGO') {
              this.pagarPixTaPago()
            } else if (this.empresa.gatewayPagamentoPix == 'SICOOB') {
              this.pagarPixSicoob();
            }
          }
        } else if (verificacao == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          this.dialogoCadastraConsumidor = true
        } else if (verificacao == 'QRCODE_INVALIDO') {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }
        this.dialogoCaptura = false
      },

      async fazerConsultaSaldo(decodedString) {
        var vm = this
        this.isLoading = true
        let resultado = await this.validaQrCode(decodedString, 'resultado')
        
        if (resultado == 'SUCESSO') {
          let saldo = await this.validaQrCode(decodedString, 'saldo')
          let consumidor = await this.validaQrCode(decodedString, 'consumidor')
          saldo = saldo == '' ? "0,00" : saldo
          vm.$refs.chamaSnackbar.snack("#0288D1", "Seu saldo é de R$ " + saldo, consumidor)
        } else if (resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
        } else if (resultado == 'QRCODE_INVALIDO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }
        this.dialogoConsultaSaldo = false
        this.isLoading = false
      },

      async fazerSolitacaoResgate(decodedString) {
        var vm = this
        this.isLoading = true
        if (await this.validaQrCode(decodedString, 'saldo') == "0,00") {
          vm.$refs.chamaSnackbar.snack("#F9A825","Não há valor no cartão de consumo para resgatar","ATENÇÃO")
        } else {
          this.solicitacaoResgate.qrCodeCartaoConsumo = decodedString
          this.dialogoSolicitaResgate = false
          this.dialogoDadosResgate = true
        }
        this.isLoading = false
      },

      async fazerConsultaHistorico(decodedString) {
        var vm = this
        this.isLoading = true
        let resultado = await this.validaQrCode(decodedString, 'resultado')

        if (resultado == "SUCESSO") {
          await axios.post(baseApiUrl + 'ExtratoCartoes/historico', {"qrCode": decodedString})
          .then(response => {
            if (response.data) {
              this.tabela.conteudo = response.data
              this.dialogoHistoricoConsumo = false
              this.dialogoTabelaHistorico = true
            }
          })
        } else if (resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
        } else if (resultado == 'QRCODE_INVALIDO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }

        this.isLoading = false
      },

      exibeDetalhes(item) {
        this.detalhesCompra = Object.assign({}, item)
        this.dialogoDetalhesConsumo = true
      },

      async criarTransacao() {
        var vm = this;
        this.isLoading = true
        let dados = {
          "empresaId": this.user.empresaId,
          "atendenteId": this.user.id,
          "qrCode": this.codigoQrCode,
          "valor": this.valorTransacao,
          "tipoTransacao": this.tipoTransacao,
          "formaTransacao": this.formaTransacao,
          "pinUsuario": this.pinTransacao,
        }
        await axios.post(baseApiUrl + 'CartoesConsumo/novaTransacao', dados)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.dialogoCaptura = false
            if (response.data.resultado == 'SUCESSO') {
              this.fechar()
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'SALDO_INSUFICIENTE') {
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
              this.dialogoCadastraConsumidor = true
            }
            else if (response.data.resultado == 'QRCODE_INVALIDO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","QR Code inválido","ATENÇÃO")
            }
            else if (response.data.resultado == 'TRANSACAO_INFORMADA_INVALIDA') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Transação informada é inválida","ATENÇÃO")
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação (" + error.response.data.error.message + ")","DESCULPE")
        })
      },

      fechar() {
        this.dialogoSolicitaPin = false
        this.dialogoCaptura = false
        this.dialogoCadastraConsumidor = false
        this.dialogoOperacao = false
        this.dialogoConsultaSaldo = false
        this.dialogoSolicitaResgate = false
        this.dialogoHistoricoConsumo = false
        this.pinTransacao = ''
      },

      async criarConsumidor() {
        var vm = this;
        this.isLoading = true

        this.consumidor.nome = this.consumidor.nome ? this.consumidor.nome : 'Avulso'

        if (this.codigoInscricao) {
          this.consumidor.qrCode = this.codigoInscricao
          this.consumidor.cpf = this.consumidor.cpf ? this.consumidor.cpf : this.codigoInscricao
          this.consumidor.whatsApp = this.consumidor.whatsApp ? this.consumidor.whatsApp : this.codigoInscricao
        } else {
          this.consumidor.qrCode = this.codigoQrCode
          this.consumidor.cpf = this.consumidor.cpf ? this.consumidor.cpf : this.codigoQrCode
          this.consumidor.whatsApp = this.consumidor.whatsApp ? this.consumidor.whatsApp : this.codigoQrCode
        }

        await axios.post(baseApiUrl + 'Consumidores/novoConsumidorComCartao', this.consumidor)
        .then(response => {
          if (response.data) {
            if (this.formaTransacao == 'CARTÃO') {
              this.isLoading = false
              this.continuarPagamentoCartao()
            } else if (this.formaTransacao == 'PIX') {
              if (this.empresa.gatewayPagamentoPix == 'ASAAS') {
                this.pagarPixAsaas()
              } else if (this.empresa.gatewayPagamentoPix == 'TAPAGO') {
                this.pagarPixTaPago()
              } else if (this.empresa.gatewayPagamentoPix == 'SICOOB') {
                this.pagarPixSicoob();
              }
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao cadastrar consumidor (" + error.response.data.error.message + ")","DESCULPE")
        })
      },

      async pegaParametrosUrl() {
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                        // Criar objeto que vai conter os parametros
          for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');         // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
          }
          if (paramArray['cod']) {
            this.tipoCodigoUrl = 'cod'
            this.codigoInscricao = paramArray['cod'].replaceAll('%3A', ':').replaceAll('%2F', '/')
            this.dialogoInformacoes = true
            this.valorCartaoConsumo = await this.validaQrCode(this.codigoInscricao, 'saldo')
          } else if (paramArray['cf']) {
            this.tipoCodigoUrl = 'cf'
            this.codigoInscricao = 'https://aiconsumer.intelite.com.br/?cf=' + paramArray['cf']
            this.valorCartaoConsumo = await this.validaQrCode(this.codigoInscricao, 'saldo')
          } else if (paramArray['s']) {
            this.urlOrigem = paramArray['s']
          }
        }
        this.isLoading = false
      },

      criarAnosVencimento() {
        let anoAtual = new Date().toISOString().substring(0, 4)
        let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14

        while ( anoAtual <= anoFinal ) {
          this.anosVencimento.push((anoAtual++).toString());
        }
      },

      async pagarCartao() {
        var vm = this
        if (!this.cobrancaAsaasCartao.creditCard.holderName || !this.cobrancaAsaasCartao.creditCard.number || !this.cobrancaAsaasCartao.creditCard.cpfCnpj || !this.cobrancaAsaasCartao.creditCard.ccv || !this.cobrancaAsaasCartao.creditCard.expiryMonth || !this.cobrancaAsaasCartao.creditCard.expiryYear || !this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode || !this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber || !this.cobrancaAsaasCartao.creditCardHolderInfo.email) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todas as informações!","ATENÇÃO")
        } else {
          this.isLoading = true
          this.cobrancaAsaasCartao.dueDate = moment().format('YYYY-MM-DD')
          this.cobrancaAsaasCartao.value = parseFloat(this.valorTransacao.replace(',','.'))
          this.cobrancaAsaasCartao.remoteIp = await this.pegaIp()
          if (this.codigoInscricao) {
            this.cobrancaAsaasCartao.qrCode = this.codigoInscricao
            this.cobrancaAsaasCartao.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
          } else {
            this.cobrancaAsaasCartao.qrCode = this.codigoQrCode
            this.cobrancaAsaasCartao.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
          }
          this.cobrancaAsaasCartao.empresaId = this.consumidor.empresaId

          await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaasCartao)
          .then(async response => {
            if (response.data) {
              this.isLoading = false
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoConfirmacao = true
            }
          }).catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
          })
        }
      },

      async pagarPixAsaas() {
        var vm = this
        this.isLoading = true
        this.cobrancaAsaas.value = parseFloat(this.valorTransacao.replace(',','.'))
        this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
        if (this.codigoInscricao) {
          this.cobrancaAsaas.qrCode = this.codigoInscricao
          this.cobrancaAsaas.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
        } else {
          this.cobrancaAsaas.qrCode = this.codigoQrCode
          this.cobrancaAsaas.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        }
        this.cobrancaAsaas.empresaId = this.consumidor.empresaId

        await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaas)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.cobrancaPix.id = response.data.paymentId
            this.cobrancaPix.qrCode = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
            this.cobrancaPix.chaveCopiaCola = response.data.qrCode.payload
            this.dialogoPagamentoPix = true
            this.consultaPagamentoPixAsaas()
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
        })
      },

      async consultaPagamentoPixAsaas() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/AsaasCobrancaConsulta', {"paymentId": this.cobrancaPix.id}).then(async response => {
            if (response.data.status == 'RECEIVED') {
              clearInterval(this.verificaPagamento)
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pagarPixTaPago() {
        var vm = this
        this.isLoading = true
        let dados = {
          "qrCode": "",
          "valor": parseFloat(this.valorTransacao.replace(',','.')),
          "descricao": "",
          "empresaId": this.consumidor.empresaId,
        }

        if (this.codigoInscricao) {
          dados.qrCode = this.codigoInscricao
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
        } else {
          dados.qrCode = this.codigoQrCode
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        }

        await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca', dados)
        .then(response => {
          if (response.data) {
            this.cobrancaPix.id = response.data.transactionId
            this.cobrancaPix.qrCode = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
            this.cobrancaPix.chaveCopiaCola = response.data.instantPayment.textContent
            this.dialogoPagamentoPix = true
            this.isLoading = false
            this.consultaPagamentoPixTaPago()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
        })
      },

      async consultaPagamentoPixTaPago() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta', {"paymentId": this.cobrancaPix.id})
          .then(async response => {
            if (response.data.status == 'APPROVED') {
              clearInterval(this.verificaPagamento)
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pagarPixSicoob() {
        var vm = this;
        this.isLoading = true;

        let dados = {
          empresaId: this.consumidor.empresaId,
          qrCode: "",
          calendario: {
            expiracao: 3600
          },
          devedor: {
            cpf: "",
            nome: "",
          },
          valor: {
            original: parseFloat(this.valorTransacao.replace(",", ".")),
          },
          chave: "",
          solicitacaoPagador: "",
        };

        if (this.codigoInscricao) {
          dados.qrCode = this.codigoInscricao;
          dados.solicitacaoPagador = "Referente a recarga do cartão de consumo nº " + this.codigoInscricao + " no AIConsumer";
        } else {
          dados.qrCode = this.codigoQrCode;
          dados.solicitacaoPagador = "Referente a recarga do cartão de consumo nº " + this.codigoQrCode + " no AIConsumer";
        }

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dados)
        .then(response => {
          if (response.data) {
            this.cobrancaPix.id = response.data.txid
            this.cobrancaPix.qrCode = response.data.brcode
            this.cobrancaPix.chaveCopiaCola = response.data.brcode
            this.dialogoPagamentoPix = true;
            this.isLoading = false;
            this.consultaPagamentoPixSicoob();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao criar transação, tente novamente", "DESCULPE");
        });
      },

      async consultaPagamentoPixSicoob() {
        try {
          this.verificaPagamento = setInterval(
            async function () {
              await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", {"paymentId": this.cobrancaPix.id})
              .then(async res3 => {
                if (res3.data.status == "APPROVED") {
                  clearInterval(this.verificaPagamento);

                  if (this.codigoInscricao) {
                    this.saldoCartao = await this.validaQrCode(this.codigoInscricao, "saldo");
                  }
                  else {
                    this.saldoCartao = await this.validaQrCode(this.codigoQrCode, "saldo");
                  }

                  this.dialogoPagamentoPix = false;
                  this.dialogoConfirmacao = true;
                }
              });
            }.bind(this), 5000);
        } catch (error) {
          clearInterval(this.verificaPagamento);
          this.isLoading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
        }
      },

      async pegaIp() {
        let ip
        await axios.get('https://api.ipify.org/?format=json')
        .then(response => {
          if (response.data) {
            ip = response.data.ip
          } else {
            ip = '127.0.0.1'
          }
        })
        .catch(() => {
          ip = '127.0.0.1'
        })
        return ip
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      closeDialog(reload = false) {
        this.dialogoConfirmacao = false
        this.dialogoPagamentoPix = false
        if (reload) {
          window.location.reload()
        }
      },

      async validaQrCode(qrCode, atributo) {
        let resultado
        await axios.post(baseApiUrl + 'QRCodes/validaQrcode', {"qrCode": qrCode})
        .then(response => {
          if (response.data) {
            resultado = response.data[atributo]
          }
        })
        return resultado
      },

      transformaData(data, formato) {
        let date = moment.utc(data).format(formato);
        return date
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async acessarConsumidor() {
        let vm = this

        if (this.login.matricula && this.login.senha) {
          this.login.urlOrigem = this.urlOrigem
          await axios.post(baseApiUrl + 'Consumidores/acessoAluno', this.login)
          .then(async response => {
            if (response.data) {
              this.consumidor = response.data.consumidor

              if (!this.consumidor.produtosBloqueados) {
                this.consumidor.produtosBloqueados = []
              }

              this.empresa = response.data.empresa
              this.tipoCodigoUrl = 'cod'
              this.codigoInscricao = response.data.consumidor.qrCode
              this.valorCartaoConsumo = await this.validaQrCode(this.codigoInscricao, 'saldo')
              this.usuarioLogado = true
              this.login.matricula = ''
              this.login.senha = ''
              this.login.urlOrigem = ''
              localStorage.setItem('consumidor', JSON.stringify(this.consumidor))
              localStorage.setItem('empresa', JSON.stringify(this.empresa))
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350","Matrícula não localizada ou senha inválida, tente novamente ou procure a secretaria da escola.","DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825","Matrícula e senha são obrigatórios","ATENÇÃO")
        }
      },

      async recuperarAcesso() {
        let vm = this

        if (this.login.matricula) {
          this.isLoading = true
  
          await axios.post(baseApiUrl + 'Consumidores/msgRecuperaSenha', {"matricula": this.login.matricula, "urlOrigem": this.urlOrigem})
          .then(response => {
            if (response.data) {
              vm.$refs.chamaSnackbar.snack("#0288D1","Mensagem enviada para o WhatsApp do responsável","INFORMAÇÃO")
              this.recuperaSenha = false
              this.login.matricula = ''
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350","Matrícula não localizada ou senha inválida, tente novamente ou procure a secretaria da escola.","DESCULPE")
          })
  
          this.isLoading = false
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe a matrícula","ATENÇÃO")
        }
      },

      sair() {
        // Limpa informações do consumidor do localStorage
        localStorage.removeItem('consumidor')
        // Reseta o estado
        this.usuarioLogado = false
        this.consumidor = {}
        this.valorCartaoConsumo = '0,00'
        this.exibeSaldoCartaoConsumo = true
      },

      fechaDialogoTaxa() {
        if (this.empresa.gatewayPagamentoPix == 'ASAAS') {
          this.pagarPixAsaas()
        }
        else if (this.empresa.gatewayPagamentoPix == 'TAPAGO') {
          this.pagarPixTaPago()
        }
        else if (this.empresa.gatewayPagamentoPix == 'SICOOB') {
          this.pagarPixSicoob();
        }

        this.dialogoTaxaCartao = false
      },

      async carregaProdutos() {
        this.produtos = [] // Limpa a lista antes de carregar
        await axios.post(baseApiUrl + 'Lojistas/porEmpresa', {"empresaId": this.consumidor.empresaId, "chave": "situacao"})
        .then(async response => {
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              await axios.post(baseApiUrl + 'Produtos/ativos', {"lojistaId": response.data[i].id})
              .then(result => {
                for (let j = 0; j < result.data.length; j++) {
                  result.data[j].lojistaNome = response.data[i].nome
                  
                  // Por padrão todos os itens são permitidos (true), exceto os que estão na lista de bloqueados
                  const bloqueado = this.consumidor.produtosBloqueados.find(p => {
                    if (typeof p === 'string') {
                      return p === result.data[j].id
                    }
                    return p.produtoId === result.data[j].id
                  })

                  result.data[j].permitido = !bloqueado

                  if (bloqueado && typeof bloqueado === 'object') {
                    result.data[j].diasPermitidos = {
                      domingo: bloqueado.domingo,
                      segunda: bloqueado.segunda,
                      terça: bloqueado.terça,
                      quarta: bloqueado.quarta,
                      quinta: bloqueado.quinta,
                      sexta: bloqueado.sexta,
                      sabado: bloqueado.sabado
                    }
                  }
                  else {
                    result.data[j].diasPermitidos = {
                      domingo: !result.data[j].permitido,
                      segunda: !result.data[j].permitido,
                      terça: !result.data[j].permitido,
                      quarta: !result.data[j].permitido,
                      quinta: !result.data[j].permitido,
                      sexta: !result.data[j].permitido,
                      sabado: !result.data[j].permitido
                    }
                  }

                  this.produtos.push(result.data[j])
                }
              })
            }
          }
        })
      },

      toggleDia(item, dia) {
        item.diasPermitidos[dia] = !item.diasPermitidos[dia]
        this.salvarBloqueioItem(item)
      },

      async salvarBloqueioItem(item) {
        let vm = this
        // Não inverte o estado aqui pois o v-model já faz isso

        if (item.permitido) {
          this.habilitarTodosDias(item)
        }
        
        let dadosEnvio = {
          "consumidorId": this.consumidor.id,
          "listaBloqueados": this.produtos.filter(item => !item.permitido).map(item => ({
            produtoId: item.id,
            ...this.resolveDiasSemana(item)
          }))
        }

        try {
          const response = await axios.post(baseApiUrl + 'Consumidores/setProdutosBloqueados', dadosEnvio)
          if (response.data) {
            this.consumidor.produtosBloqueados = response.data
            localStorage.setItem('consumidor', JSON.stringify(this.consumidor))
            this.snackbar = true
            this.textoSnackbar = item.permitido ? 'Item permitido' : 'Item bloqueado'
            this.timeout = 2000
          }
        } catch (error) {
          // Em caso de erro, reverte o estado do toggle
          item.permitido = !item.permitido
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível salvar as alterações. " + error.response.data.error.message, "ERRO")
        }
      },

      resolveDiasSemana(produto) {
        const dias = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sabado']
        const diasPermitidos = produto.diasPermitidos || {}

        return dias.reduce((acc, dia) => {
          acc[dia] = typeof diasPermitidos[dia] === 'boolean' ? diasPermitidos[dia] : true

          return acc
        }, {})
      },

      habilitarTodosDias(item) {
        for (let dia in item.diasPermitidos) {
          item.diasPermitidos[dia] = true
        }
      },

      resumoDias(item) {
        const mapa = {
          domingo: 'Dom',
          segunda: 'Seg',
          terça: 'Ter',
          quarta: 'Qua',
          quinta: 'Qui',
          sexta: 'Sex',
          sabado: 'Sab'
        }

        // agora false = permitido
        const diasPermitidos = Object.keys(item.diasPermitidos)
          .filter(d => !item.diasPermitidos[d])

        if (diasPermitidos.length === 0) {
          return 'Bloqueado todos os dias'
        }

        if (diasPermitidos.length === 7) {
          return 'Permitido todos os dias'
        }

        return 'Permitido: ' + diasPermitidos.map(d => mapa[d]).join(', ')
      },

      async alterarSenha() {
        let vm = this

        if (!this.pinAntigo || !this.pinNovo || !this.confirmacaoPin) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Todos os campos são obrigatórios", "ATENÇÃO")
          return
        }

        if (this.pinNovo != this.confirmacaoPin) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "A nova senha e a confirmação não coincidem", "ATENÇÃO")
          return
        }

        if (this.pinAntigo === this.pinNovo) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "A nova senha deve ser diferente da atual", "ATENÇÃO")
          return 
        }

        if (this.pinNovo.length < 4) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "A nova senha deve ter pelo menos 4 caracteres", "ATENÇÃO")
          return 
        }
        
        this.isLoading = true
        let dados = {
          consumidorId: this.consumidor.id,
          pinAntigo: this.pinAntigo,
          pinNovo: this.pinNovo
        }

        await axios.post(baseApiUrl + 'Consumidores/alteraPin', dados)
        .then(response => {
          if (response.data) {
            this.dialogoAlterarSenha = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Senha alterada!","SUCESSO")
            this.consumidor.senha = this.pinNovo
            localStorage.setItem('consumidor', JSON.stringify(this.consumidor))
          }
        })
        .catch(error => {
          vm.$refs.chamaSnackbar.snack("#EF5350", error.response.data.error.message, "DESCULPE")
        })

        this.isLoading = false
      },

      async alterarDadosCadastrais() {
        let vm = this

        if (!this.dadosCadastrais.cpf || !CpfValidate(this.dadosCadastrais.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "CPF inválido ou não preenchido", "ATENÇÃO")
          return
        }

        if (!this.dadosCadastrais.nome || this.dadosCadastrais.nome.trim().length === 0) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Nome não pode estar vazio", "ATENÇÃO")
          return
        }

        if (!this.dadosCadastrais.whatsApp || this.dadosCadastrais.whatsApp.length < 15) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Telefone inválido ou não preenchido. Deve conter 11 dígitos", "ATENÇÃO")
          return
        }

        if (!this.dadosCadastrais.dataNascimento || !/^\d{2}\/\d{2}\/\d{4}$/.test(this.dadosCadastrais.dataNascimento)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Data de nascimento inválida ou não preenchida", "ATENÇÃO")
          return
        }

        if (!this.dadosCadastrais.turma || this.dadosCadastrais.turma.trim().length === 0) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Turma não pode estar vazia", "ATENÇÃO")
          return
        }

        if (!this.dadosCadastrais.responsavel || this.dadosCadastrais.responsavel.trim().length === 0) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Responsável não pode estar vazio.", "ATENÇÃO")
          return
        }

        this.isLoading = true

        // Se tiver uma nova foto em base64, envia para o servidor
        let dadosEnvio = { ...this.dadosCadastrais }
        
        // Adiciona o ID da empresa para processamento da foto
        if (this.consumidor.empresaId) {
          dadosEnvio.empresaId = this.consumidor.empresaId
        }
        
        if (this.dadosCadastrais.hashBase64) {
          vm.$refs.chamaSnackbar.snack("#0288D1", "Enviando nova foto para processamento...", "INFO")
          // Mantém a propriedade hashBase64 para enviar ao servidor
        } else {
          // Se não tiver nova foto, não envia o campo hashBase64
          delete dadosEnvio.hashBase64
        }

        await axios.post(baseApiUrl + 'Consumidores/alteraDados', dadosEnvio)
        .then(response => {
          if (response.data) {
            this.consumidor.cpf = this.dadosCadastrais.cpf
            this.consumidor.nome = this.dadosCadastrais.nome
            this.consumidor.whatsApp = this.dadosCadastrais.whatsApp
            this.consumidor.dataNascimento = this.dadosCadastrais.dataNascimento
            this.consumidor.turma = this.dadosCadastrais.turma
            this.consumidor.responsavel = this.dadosCadastrais.responsavel
            
            // Atualiza a foto apenas se o backend retornar uma nova URL
            if (response.data.foto) {
              //console.log("Nova foto recebida:", response.data.foto)
              this.consumidor.foto = response.data.foto
            }
            
            localStorage.setItem('consumidor', JSON.stringify(this.consumidor))
            this.dialogoAlterarDadosCadastrais = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Informações salvas!", "SUCESSO")
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao salvar informações, tente novamente", "DESCULPE")
        })

        this.isLoading = false
      },

      houveAlteracao(dadosOriginais, dadosEditados) {
        return Object.keys(dadosEditados)
          .filter(chave => chave !== "consumidorId")
          .some(chave => dadosOriginais[chave] !== dadosEditados[chave]);
      },

      exibeQRCode(comprovante){
        this.comprovanteAtual = comprovante
        this.exibeComprovanteQRCode = true
      },

      toggleSaldoVisibility() {
        this.exibeSaldoCartaoConsumo = !this.exibeSaldoCartaoConsumo;
      },

      // Métodos para o histórico de transações
      formatDateTime(dateTimeString) {
        if (!dateTimeString) return '';
        
        // Usando moment para manter o fuso horário original do servidor
        // O parâmetro utc impede que o moment faça ajustes de fuso horário local
        return moment.utc(dateTimeString).format('DD/MM/YYYY · HH:mm');
      },
      
      getTransactionIcon(type, statusPagamento) {
        // Para depósitos pendentes, usar ícone específico
        if (type === 'DEPÓSITO' && statusPagamento === 'PENDENTE') {
          return 'mdi-clock-outline';
        }

        // Para os demais casos, manter a lógica original
        switch(type) {
          case 'DEPÓSITO': return 'mdi-cash-plus';
          case 'CONSUMO': return 'mdi-cart-outline';
          case 'ESTORNO': return 'mdi-cash-refund';
          case 'TAXA': return 'mdi-percent';
          default: return 'mdi-cash';
        }
      },
      
      getTransactionColor(type, statusPagamento) {
        // Para depósitos pendentes, usar cor específica
        if (type === 'DEPÓSITO' && statusPagamento === 'PENDENTE') {
          return '#FF9800'; // Cor de alerta (laranja)
        }

        // Para os demais casos, manter a lógica original
        switch(type) {
          case 'DEPÓSITO': return '#4CAF50';
          case 'CONSUMO': return '#F44336';
          case 'ESTORNO': return '#FF9800';
          case 'TAXA': return '#9C27B0';
          default: return '#757575';
        }
      },
      
      getTransactionTitle(transaction) {
        const type = typeof transaction === 'string' ? transaction : transaction.tipoTransacao;
        const formaTransacao = typeof transaction === 'string' ? '' : (transaction.formaTransacao || '');

        if (formaTransacao === 'ADMIN_AJUSTE') {
          return type === 'DEPÓSITO' ? 'Ajuste do Admin (Crédito)' : 'Ajuste do Admin (Débito)';
        }

        if (formaTransacao === 'ADMIN_TRANSFERENCIA') {
          return type === 'DEPÓSITO' ? 'Transferência (Recebida)' : 'Transferência (Enviada)';
        }

        if (formaTransacao === 'ADMIN_TRANSFERENCIA_ESTORNO') {
          return 'Estorno de Transferência';
        }

        switch(type) {
          case 'DEPÓSITO': return 'Recarga';
          case 'CONSUMO': return 'Consumo';
          case 'ESTORNO': return 'Estorno';
          case 'TAXA': return 'Taxa de serviço';
          default: return 'Transação';
        }
      },

      isAdminTransaction(transaction) {
        if (!transaction || !transaction.formaTransacao) return false;
        return String(transaction.formaTransacao).startsWith('ADMIN');
      },

      getAdminReason(transaction) {
        if (!transaction) return '';

        let rawObs = transaction.observacao || '';
        if (!rawObs && Array.isArray(transaction.itens) && transaction.itens.length > 0) {
          const itemComObs = transaction.itens.find(item => item && item.observacao);
          rawObs = itemComObs ? itemComObs.observacao : '';
        }

        if (!rawObs) return '';

        const obs = String(rawObs).trim();
        if (!obs) return '';

        if (obs.includes(' — ')) {
          const partes = obs.split(' — ');
          return partes[partes.length - 1].trim();
        }

        return obs;
      },

      getAdminCounterparty(transaction) {
        if (!transaction) return '';

        let rawObs = transaction.observacao || '';
        if (!rawObs && Array.isArray(transaction.itens) && transaction.itens.length > 0) {
          const itemComObs = transaction.itens.find(item => item && item.observacao);
          rawObs = itemComObs ? itemComObs.observacao : '';
        }

        if (!rawObs) return '';
        const obs = String(rawObs).trim();
        if (!obs) return '';

        const prefixoPara = 'Transferência admin p/ ';
        const prefixoDe = 'Transferência admin de ';
        const parteSemMotivo = obs.split(' — ')[0].trim();
        const limparCartao = (texto) => String(texto || '').replace(/\s*\(cartão [^)]+\)\s*$/i, '').trim();

        if (parteSemMotivo.startsWith(prefixoPara)) {
          return 'Para: ' + limparCartao(parteSemMotivo.replace(prefixoPara, '').trim());
        }

        if (parteSemMotivo.startsWith(prefixoDe)) {
          return 'De: ' + limparCartao(parteSemMotivo.replace(prefixoDe, '').trim());
        }

        return '';
      },
      
      getMesAbreviado(mesNumero) {
        const meses = {
          '01': 'JAN',
          '02': 'FEV',
          '03': 'MAR',
          '04': 'ABR',
          '05': 'MAI',
          '06': 'JUN',
          '07': 'JUL',
          '08': 'AGO',
          '09': 'SET',
          '10': 'OUT',
          '11': 'NOV',
          '12': 'DEZ'
        };
        return meses[mesNumero] || mesNumero;
      },

      groupTransactionsByMonth(transactions) {
        if (!transactions || transactions.length === 0) return [];
        
        // Ordenar transações por data (mais recentes primeiro)
        const sortedTransactions = [...transactions].sort((a, b) => 
          new Date(b.created) - new Date(a.created)
        );
        
        // Agrupar por mês e ano
        const groups = [];
        let currentMonth = '';
        let currentYear = '';
        let currentGroup = null;
        
        sortedTransactions.forEach(transaction => {
          const date = moment.utc(transaction.created);
          const month = date.format('MM');
          const year = date.format('YYYY');
          const monthYear = `${month}-${year}`;
          
          if (monthYear !== `${currentMonth}-${currentYear}`) {
            // Novo grupo
            currentMonth = month;
            currentYear = year;
            currentGroup = { 
              month: month, 
              year: year,
              items: [] 
            };
            groups.push(currentGroup);
          }
          
          // Adicionar transação ao grupo atual
          currentGroup.items.push(transaction);
        });
        
        return groups;
      },

      getMesCompleto(month) {
        const meses = {
          '01': 'Janeiro',
          '02': 'Fevereiro',
          '03': 'Março',
          '04': 'Abril',
          '05': 'Maio',
          '06': 'Junho',
          '07': 'Julho',
          '08': 'Agosto',
          '09': 'Setembro',
          '10': 'Outubro',
          '11': 'Novembro',
          '12': 'Dezembro'
        };
        return meses[month] || month;
      },

      goToRestricoes() {
        this.dialogoItensBloqueados = true;
      },

      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },

      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          let vm = this
          var reader = new FileReader()
          var file = this.files[0]

          //salva a base64 na variável
          reader.onloadend = function() {
            document.getElementById('foto').value = reader.result
            vm.dadosCadastrais.hashBase64 = reader.result
            vm.dialogoCamera = false
            // Salvar automaticamente após selecionar a foto
            vm.alterarDadosCadastrais()
          };

          //Gera base64
          reader.readAsDataURL(file.file);
        }
      },

      async capturarFoto() {
        this.dadosCadastrais.hashBase64 = await this.$refs.camera.capturar();
        this.dialogoCamera = false
        // Salvar automaticamente após capturar a foto
        this.alterarDadosCadastrais()
      },

      removerFoto() {
        this.dadosCadastrais.hashBase64 = ''
        this.dadosCadastrais.foto = ''
      },

      async definirLimiteCartao() {
        this.isLoading = true
        let vm = this
        let dadosEnvio = {
          limiteDiarioConsumo: this.valorParaNumero(this.valorLimiteCartao),
          consumidorId: this.consumidor.id
        }

        await axios.post(baseApiUrl + 'Consumidores/alteraDados', dadosEnvio)
        .then(response => {
          if (response.data) {
            vm.$refs.chamaSnackbar.snack("#0288D1", "Limite definido!", "SUCESSO")
            this.consumidor.limiteDiarioConsumo = response.data.limiteDiarioConsumo
            localStorage.setItem('consumidor', JSON.stringify(this.consumidor))
            this.dialogoLimiteCartao = false
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao definir limite. Por favor, tente novamente.", "DESCULPE")
        })

        this.isLoading = false
      },

      valorParaNumero(valor) {
        return Number(valor.replace(/\./g, '').replace(',', '.'));
      },

      retornaValorFormatado(valor) {
        return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace("R$", "").trim()
      },
    },
    directives: {money: VMoney}
  }
</script>

<style scoped>
  /* Estilos gerais */
  .limiter {
    width: 100%;
    margin: 0 auto;
    min-height: 100vh;
    position: relative;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  .form-campos {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .form-field {
    margin-bottom: 4px !important;
  }

  .card-box-container {
    margin-top: -60px;
    padding-bottom: 20px;
  }

  .card-circle-1 {
    width: 204px;
    height: 204px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.19);
    position: absolute;
    top: 15px;
    right: -44px;
    z-index: 0;
  }

  .card-circle-2 {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.15);
    position: absolute;
    top: 47px;
    right: -19px;
    z-index: 1;
  }

  /* Estilo para os cards */
  .v-card.rounded-lg {
    border-radius: 12px !important;
    transition: transform 0.2s, box-shadow 0.2s;
  }
  
  .v-card.hover:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.1) !important;
  }
  
  /* Estilo para o card do saldo */
  .mb-4 {
    margin-bottom: 20px !important;
  }
  
  /* Estilo para os ícones nos avatares */
  .v-list-item-avatar.rounded-lg {
    border-radius: 8px !important;
  }
  
  /* Estilo para o logo */
  .logo-img {
    max-width: 180px;
    height: auto;
  }
  
  /* Estilo para o texto nos cards */
  .v-list-item-subtitle {
    opacity: 0.7;
    font-size: 0.85rem;
  }
  
  /* Ajustes no container */
  .px-4 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  
  .py-6 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  
  /* Estilo para os diálogos */
  .v-dialog .v-card {
    border-radius: 12px;
  }
  
  /* Estilo para o footer */
  .v-footer.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
  }
  
  /* Ajuste para garantir que o conteúdo não fique escondido atrás do footer */
  .pb-16 {
    padding-bottom: 64px !important;
  }
  
  /* Estilos para o card de saldo moderno */
  .balance-card {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
    position: relative;
    overflow: hidden !important;
  }
  
  .card-bg-gradient {
    background: linear-gradient(135deg, #1976D2, #0D47A1, #0277BD);
    position: relative;
    overflow: hidden;
    min-height: 180px;
  }
  
  .balance-display {
    font-size: 2rem;
    font-weight: 700;
    display: block;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .opacity-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    width: 100%;
  }
  
  .action-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(5px);
    border-radius: 50%;
    transition: all 0.2s ease;
    min-width: 32px !important;
    height: 32px !important;
    cursor: pointer;
    z-index: 5;
  }
  
  .action-btn:hover {
    background: rgba(255, 255, 255, 0.25) !important;
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  }
  
  .action-btn:active {
    transform: scale(0.95);
  }
  
  .visibility-btn {
    transition: all 0.2s ease;
    border: 2px solid #1976D2 !important;
    cursor: pointer;
    min-width: 36px !important;
    height: 36px !important;
    z-index: 5;
  }
  
  .visibility-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  }
  
  .visibility-btn:active {
    transform: scale(0.95);
  }
  
  /* Elementos decorativos do card */
  .card-chip {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 40px;
    height: 30px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    transform: rotate(45deg);
  }
  
  .card-circle-1 {
    position: absolute;
    bottom: -50px;
    right: -20px;
    width: 120px;
    height: 120px;
    border-radius: 60px;
    background: rgba(255, 255, 255, 0.05);
  }
  
  .card-circle-2 {
    position: absolute;
    top: -40px;
    left: -30px;
    width: 160px;
    height: 160px;
    border-radius: 80px;
    background: rgba(255, 255, 255, 0.03);
  }
  
  /* Estilo para botões de ação destacados */
  .action-btn-highlight {
    background-color: white !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
    transition: all 0.2s ease;
    position: relative;
    z-index: 10;
    border: 2px solid rgba(255, 255, 255, 0.9) !important;
  }
  
  .action-btn-highlight:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3) !important;
  }
  
  .action-btn-highlight:active {
    transform: scale(0.95);
  }
  
  .action-btn-highlight .v-icon {
    font-size: 18px;
  }
  
  /* Estilos para o histórico de transações */
  .transactions-list {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 4px;
  }
  
  .transactions-list::-webkit-scrollbar {
    width: 6px;
  }
  
  .transactions-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  .transactions-list::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 10px;
  }

  .transactions-list::-webkit-scrollbar-thumb:hover {
    background: #9e9e9e;
  }
  
  .transaction-card {
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
    border-radius: 8px !important;
  }
  
  .transaction-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
  }
  
  /* Estilo minimalista para o extrato bancário */
  .transaction-list {
    max-height: 400px;
    overflow-y: auto;
  }
  
  .transaction-list::-webkit-scrollbar {
    width: 4px;
  }
  
  .transaction-list::-webkit-scrollbar-track {
    background: #f5f5f5;
  }
  
  .transaction-list::-webkit-scrollbar-thumb {
    background: #bdbdbd;
  }
  
  .transaction-list::-webkit-scrollbar-thumb:hover {
    background: #9e9e9e;
  }
  
  .transaction-item {
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .transaction-item:hover {
    background-color: rgba(0,0,0,0.03) !important;
  }
  
  .transaction-header {
    position: sticky;
    top: 0;
    z-index: 1;
  }
  
  /* Estilos para o formato de data */
  .date-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    position: relative;
  }
  
  .date-day {
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
  }
  
  .date-month {
    font-size: 12px;
    text-transform: uppercase;
    line-height: 1;
    margin-top: 2px;
  }
  
  .date-time {
    font-size: 12px;
    opacity: 0.7;
  }

  .month-divider {
    background-color: #f5f5f5;
    padding: 8px;
    margin: 8px 0;
    border-radius: 4px;
}

.qr-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.qr-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.qr-container {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pix-code-field {
  font-family: monospace;
  letter-spacing: 0.5px;
  background-color: #f5f5f5;
}

.pix-code-field >>> input {
  color: #455a64;
  font-size: 13px;
}

.text-green {
  color: #4CAF50 !important;
}

.headline {
  font-size: 24px !important;
  line-height: 32px !important;
}

.v-expansion-panel::before {
  box-shadow: none !important;
}

.v-expansion-panel-header {
  padding: 8px 0;
}

.v-expansion-panel-content__wrap {
  padding: 0 8px 16px;
}

/* Animação para o QR code */
.qr-container {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.restricoes-icon {
  background-color: #1565C0 !important;
  color: white !important;
}

.position-relative {
  position: relative;
}

.photo-edit-overlay {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0, 10px);
}
</style>

<style lang="scss" scoped>
// ... existing code ...

.card-bg-gradient {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
  border-radius: 16px;
  position: relative;
  overflow: hidden;
}

.avatar-clickable {
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
    opacity: 0.9;
  }
}

.dia-chip {
  color: white;
  width: 100%;
  justify-content: center;
}

// ... existing code ...
</style>